import BookWithConfidence from "@sitewide/components/BookWithConfidence";
import SitewideAutocomplete from "@sitewide/components/SitewideAutocomplete";
import initExperiments from "@sitewide/helpers/experiments";
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "vite/modulepreload-polyfill";

import BookingDrawer from "@/booking/components/constructs/BookingDrawer";
import { BookingEvent } from "@/booking/eventEnums";
import { ColorEnum } from "@/enums";

import NewsLetter from "./components/NewsLetter";

interface ExperimentAction {
  action: "set" | "clear";
  cookie?: string;
}

declare global {
  interface Window {
    experimentsQueue: ExperimentAction[];
  }
}

ReactDOM.createRoot(document.querySelector(".header-sitewide")!).render(
  <React.StrictMode>
    <React.Suspense>
      <BrowserRouter>
        <SitewideAutocomplete
          color={ColorEnum.STEELBLUE}
          iconColor={ColorEnum.WHITE}
        />
      </BrowserRouter>
    </React.Suspense>
  </React.StrictMode>,
);

ReactDOM.createRoot(document.querySelector(".nav-sitewide")!).render(
  <React.StrictMode>
    <React.Suspense>
      <BrowserRouter>
        <SitewideAutocomplete
          color={ColorEnum.STEELBLUE}
          iconColor={ColorEnum.WHITE}
          mobile
        />
      </BrowserRouter>
    </React.Suspense>
  </React.StrictMode>,
);

const footerBannerElement = document.querySelector(".footer-enquiry-banner");
if (footerBannerElement) {
  ReactDOM.createRoot(footerBannerElement).render(
    <React.StrictMode>
      <React.Suspense>
        <BrowserRouter>
          <BookWithConfidence />
        </BrowserRouter>
      </React.Suspense>
    </React.StrictMode>,
  );
}

const onlineBookingElement = document.querySelector("#online-booking-root");

const initOnlineBooking = () => {
  const buttons = document.querySelectorAll<HTMLButtonElement>(
    "[role='button'][data-target='#online-booking-modal']",
  );

  if (buttons.length) {
    buttons.forEach((button) => {
      // Remove existing listener to avoid duplicates
      const newButton = button.cloneNode(true) as HTMLButtonElement;
      button.parentNode?.replaceChild(newButton, button);

      newButton.addEventListener("click", (e) => {
        e.preventDefault();
        const eventData = {
          packageId: newButton.dataset.packageId,
          groupSize: newButton.dataset.groupSize,
          arrivalDate: newButton.dataset.arrivalDate,
        };
        window.postMessage(
          {
            eventType: BookingEvent.OPEN_DRAWER,
            event: eventData,
          },
          window.location.origin,
        );
      });
    });
  }
};

if (onlineBookingElement) {
  const root = ReactDOM.createRoot(onlineBookingElement);
  root.render(
    <React.StrictMode>
      <React.Suspense>
        <BookingDrawer />
      </React.Suspense>
    </React.StrictMode>,
  );

  // Initialize on page load
  initOnlineBooking();

  // Listen for custom event to re-initialize after AJAX updates
  document.addEventListener("reinitializeBookings", () => {
    initOnlineBooking();
  });
}

initExperiments();

const newsletterElement = document.querySelector("#newsletter-form");
if (newsletterElement) {
  ReactDOM.createRoot(newsletterElement).render(
    <React.StrictMode>
      <React.Suspense>
        <BrowserRouter>
          <NewsLetter />
        </BrowserRouter>
      </React.Suspense>
    </React.StrictMode>,
  );
}
